import { useStatsigClient } from '@statsig/react-bindings';

const DYNAMIC_CONFIG_NAME = 'onboarding_call_calendly_urls';

// Defaults (used if DynamicConfig is not available)
const DEFAULT_EM_URL = '';
const DEFAULT_OA_URL = '';
const DEFAULT_EM_SLUG = 'enrollment-manager-call';
const DEFAULT_OA_SLUG = 'onboarding-accountant-call';

/**
 * Hook to get Calendly URLs and slugs from Statsig DynamicConfig
 *
 * Returns EM and OA call URLs and slugs configured in Statsig.
 * Slugs are used to filter CalendlyLog entries by event type.
 * Falls back to defaults if config is not available.
 */
export default function useCalendlyUrls() {
    // Safely handle undefined from useStatsigClient (e.g., in test environments without Statsig)
    const statsigClient = useStatsigClient();
    const client = statsigClient?.client;

    // Safely get dynamic config (may not exist in test environments)
    const config = client?.getDynamicConfig?.(DYNAMIC_CONFIG_NAME);

    return {
        emCallUrl: config?.get('em_call_url', DEFAULT_EM_URL) ?? DEFAULT_EM_URL,
        oaCallUrl: config?.get('oa_call_url', DEFAULT_OA_URL) ?? DEFAULT_OA_URL,
        emSlug: config?.get('em_slug', DEFAULT_EM_SLUG) ?? DEFAULT_EM_SLUG,
        oaSlug: config?.get('oa_slug', DEFAULT_OA_SLUG) ?? DEFAULT_OA_SLUG,
    };
}
